/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateProjectRequestPost } from '../../models/create-project-request-post';
import { CreateProjectResponse } from '../../models/create-project-response';

export interface ProjectsControllerCreateProject$Params {
      body: CreateProjectRequestPost
}

export function projectsControllerCreateProject(http: HttpClient, rootUrl: string, params: ProjectsControllerCreateProject$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectResponse>> {
  const rb = new RequestBuilder(rootUrl, projectsControllerCreateProject.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateProjectResponse>;
    })
  );
}

projectsControllerCreateProject.PATH = '/planning-projects/v1-develop/projects';
